'use strict';

var Layout = require('mag-component-layout'),
    dom    = require('spa-dom'),

    tag = dom.tag;


function InfoPanel () {
    var className = 'infoPanel hidden';

    if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
        className += ' longpress';
    }

    this.$movie = tag(
        'div',
        {className: className},
        this.$title = tag('div', {className: 'title'}),

        this.$rating = tag(
            'div',
            {className: 'ratingContainer'},
            this.$ratingKino = tag('div', {className: 'ratingKino'}),
            this.$ratingImdb = tag('div', {className: 'ratingImdb'}),
            this.$ageLimit = tag('div', {className: 'ageLimit'})
        ),

        tag('div', {className: 'line'},
            tag('div', {className: 'leftPart'}, gettext('Country:')),
            this.$country = tag('div', {className: 'rightPart'})),

        tag(
            'div',
            {className: 'line'},
            tag('div', {className: 'leftPart'}, gettext('Year:')),
            this.$year = tag('div', {className: 'rightPart'})
        ),

        tag(
            'div',
            {className: 'line'},
            tag('div', {className: 'leftPart'}, gettext('Genre:')),
            this.$genre = tag('div', {className: 'rightPart'})
        ),

        tag(
            'div',
            {className: 'line'},
            tag('div', {className: 'leftPart'}, gettext('Duration:')),
            this.$duration = tag('div', {className: 'rightPart'})
        ),

        this.$description = tag('div', {className: 'description'})
    );

    this.$info = tag('div', {className: 'information'});

    this.$seeMore = tag(
        'div',
        {className: 'seeMoreContainer'},
        tag('div', {className: 'textBlock'}, gettext('See more'))
    );

    this.layout = new Layout({
        focusable: false,
        data: [this.$movie, this.$info, this.$seeMore],
        className: 'rightPanel'
    });
}

// correct constructor name
InfoPanel.prototype.constructor = InfoPanel;


/**
 * Fill movie information.
 *
 * @param {Object} data - movie information
 */
InfoPanel.prototype.fillMovie = function ( data ) {
    var needRating = false;

    // var screenshots;
    if ( data ) {
        // screenshots = data.screenshots;
        if (
            data
            && (data.censored || (data.category && data.category.censored))
            && !core.accessControl.state
        ) {
            this.layout.$node.style.backgroundImage = '';
            this.$movie.classList.add('censored');
        } else {
            this.$movie.classList.remove('censored');
            // if ( screenshots && screenshots.length ) {
            //     this.layout.$node.style.backgroundImage = 'url(' + screenshots[0] + ')';
            // } else {
            //     this.layout.$node.style.backgroundImage = '';
            // }
        }
        this.$title.innerText = data.name;

        if ( data['rating_imdb'] ) {
            needRating = true;
            this.$ratingImdb.innerText = data.rating_imdb;
            this.$ratingImdb.style.display = '';
        } else {
            this.$ratingImdb.style.display = 'none';
        }

        if ( data['rating_kinopoisk'] ) {
            needRating = true;
            this.$ratingKino.innerText = data.rating_kinopoisk;
            this.$ratingKino.style.display = '';
        } else {
            this.$ratingKino.style.display = 'none';
        }

        if ( data.age ) {
            needRating = true;
            this.$ageLimit.innerText = data.age;
            this.$ageLimit.style.display = '';
        } else {
            this.$ageLimit.style.display = 'none';
        }

        if ( needRating ) {
            this.$rating.style.display = '';
        } else {
            this.$rating.style.display = 'none';
        }

        this.$genre.innerText = data.genre;
        this.$country.innerText = data.country;
        this.$year.innerText = data['year_end']
            ? data.year + ' - ' + data['year_end']
            : data.year;
        this.$duration.innerText = data.duration + ' ' + gettext('minutes');
        this.$description.innerText = data.description;
        if ( data.favorite ) {
            this.$movie.classList.add('inFavorite');
        } else {
            this.$movie.classList.remove('inFavorite');
        }
    } else {
        this.layout.$node.style.backgroundImage = '';
    }
};


/**
 * Show information panel with text description.
 */
InfoPanel.prototype.showInfo = function () {
    this.$info.classList.remove('hidden');
    this.$movie.classList.add('hidden');
    this.$seeMore.classList.add('hidden');
    this.layout.$node.style.backgroundImage = '';
};


/**
 * Show information panel with movie description.
 */
InfoPanel.prototype.showMovie = function () {
    this.$info.classList.add('hidden');
    this.$movie.classList.remove('hidden');
    this.$seeMore.classList.add('hidden');
};


/**
 * Show see more panel.
 */
InfoPanel.prototype.showSeeMore = function () {
    this.$info.classList.add('hidden');
    this.$movie.classList.add('hidden');
    this.$seeMore.classList.remove('hidden');
};


/**
 * Clear rating information.
 */
InfoPanel.prototype.clearRating = function () {
    this.$ratingImdb.style.display = 'none';
    this.$ratingKino.style.display = 'none';
    this.$ageLimit.style.display = 'none';
};

module.exports = InfoPanel;
